<template>
  <div>
    <div class="title">
      <h2 class="toTop">結論</h2>
      <span>文/呂鈺秀、邱鈺珊</span>
      <!-- <span>2019 / 04 / 06</span> -->
    </div>
    <hr />
    <p class="firstRow"></p>

    <h3>壹、年度社會背景</h3>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2020年初開始，全球大爆發的嚴重特殊傳染性肺炎（COVID-19），2022年仍繼續肆虐，但在年初之時，本土疫情控制得當。1月1日本土累計確診總人數為17,050人，死亡累積總人數850人，當日本土確診數為0。之後雖有零星確診數，但國民生活基本正常。而4月開始，染病者逐漸增多，先是4月1日本土確診數破百（104人），4月15日破千（1,209人），4月28日破萬（11,353人），累計死亡人數也於5月13日破千（1,009）。截至7月31日止，本土當日確診人數為20,824人，累計死亡人數為8,927人，累計確診總人口數為4,588,185人。<sup>1</sup>
    </p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在這波疫情下，上半年初逐漸回溫的音樂活動，又在4月到6月縮減場次。所幸多數成年人接種了疫苗，患病者多為輕症，政府也適時修訂隔離政策以及規範確診情況。因此雖有4到6月之間，部分藝文活動因演出者確診遭受隔離，而被取消或延期，但有些活動仍照常舉行。除了改以視訊或部分視訊演出，另也有縮減活動規模的形式。為因應疫情，藝文活動形式這幾年正逐漸轉向，此可透過近年各子領域月曆觀察發現。
    </p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2022年的下半年度，國際社會間逐漸走向與病毒共存，10月13日起，入境人員免除居家檢疫，12月1日起，更放寬室外免戴口罩，許多從疫情開始被推延的音樂相關活動，都在下半年各展特色，音樂活動逐漸熱絡起來。此情形從每個子領域的活動月曆可看出。
    </p>
    <h3>貳、音樂活動觀察資料分析與判讀</h3>
    <p>一、調查之團體與個人數量</p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本年度年鑑由主持人規劃編輯理念與體例、聘請相關音樂領域專家學者14人，組成編輯小組，完成年鑑主體內容，包括觀察評介專文、活動月曆、活動觀察紀錄、年度活動影像精選和團體及個人名錄、重要音樂活動一覽表等附錄資料，並將綜整編輯成果，提出整體資料分析判讀與建議。表1為各子領域所觀察之團體數量一覽。
    </p>
    <span>表1：各子領域研究的團體數量</span>
    <table rules="all" border="1" style="border: 1px solid" cellpadding="5">
      <tbody>
        <tr>
          <td class="tableCenter" width="151">
            <p>子領域名稱</p>
          </td>
          <td class="tableCenter" width="132">
            <p>團體名錄數量</p>
          </td>
          <td class="tableCenter" width="123">
            <p>已立案團體</p>
          </td>
          <td class="tableCenter" width="123">
            <p>已立案百分比</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="151">
            <p>南管音樂</p>
          </td>
          <td class="tableCenter" width="132">
            <p>66</p>
          </td>
          <td class="tableCenter" width="123">
            <p>40</p>
          </td>
          <td class="tableCenter" width="123">
            <p>60%</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="151">
            <p>北管音樂</p>
          </td>
          <td class="tableCenter" width="132">
            <p>119</p>
          </td>
          <td class="tableCenter" width="123">
            <p>32</p>
          </td>
          <td class="tableCenter" width="123">
            <p>27%</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="151">
            <p>福佬歌謠</p>
          </td>
          <td class="tableCenter" width="132">
            <p>13</p>
          </td>
          <td class="tableCenter" width="123">
            <p>10</p>
          </td>
          <td class="tableCenter" width="123">
            <p>77%</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="151">
            <p>客家音樂</p>
          </td>
          <td class="tableCenter" width="132">
            <p>92</p>
          </td>
          <td class="tableCenter" width="123">
            <p>47</p>
          </td>
          <td class="tableCenter" width="123">
            <p>51%</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="151">
            <p>原住民音樂</p>
          </td>
          <td class="tableCenter" width="132">
            <p>72</p>
          </td>
          <td class="tableCenter" width="123">
            <p>29</p>
          </td>
          <td class="tableCenter" width="123">
            <p>40%</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="151">
            <p>佛教、釋教音樂</p>
          </td>
          <td class="tableCenter" width="132">
            <p>62</p>
          </td>
          <td class="tableCenter" width="123">
            <p>54</p>
          </td>
          <td class="tableCenter" width="123">
            <p>87%</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="151">
            <p>道教、法教音樂</p>
          </td>
          <td class="tableCenter" width="132">
            <p>14</p>
          </td>
          <td class="tableCenter" width="123">
            <p>8</p>
          </td>
          <td class="tableCenter" width="123">
            <p>57%</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="151">
            <p>國樂</p>
          </td>
          <td class="tableCenter" width="132">
            <p>224</p>
          </td>
          <td class="tableCenter" width="123">
            <p>181</p>
          </td>
          <td class="tableCenter" width="123">
            <p>81%</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="151">
            <p>西樂及混合編制</p>
          </td>
          <td class="tableCenter" width="132">
            <p>124</p>
          </td>
          <td class="tableCenter" width="123">
            <p>124</p>
          </td>
          <td class="tableCenter" width="123">
            <p>100%</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="151">
            <p>跨界音樂與其他</p>
          </td>
          <td class="tableCenter" width="132">
            <p>57</p>
          </td>
          <td class="tableCenter" width="123">
            <p>26</p>
          </td>
          <td class="tableCenter" width="123">
            <p>46%</p>
          </td>
        </tr>
      </tbody>
    </table>
    <p></p>
    <p><strong>二、資料來源</strong></p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;資料來源方面，不同子領域除了透過文獻資料，搜尋相關網站訊息之外，傳統音樂部分，包含南管音樂、北管音樂、福佬音樂、客家音樂、原住民音樂、宗教音樂中的佛、釋、道、法、釋奠樂等，因為這些樂種許多相關訊息，並非經由網路流通，更多的是透過口耳相傳與當地人告知，因此在資料來源上，應用較多的田野調查，活動的記錄，也多透過實地訪查觀察而書寫，所獲多為第一手的資料。至於藝術（當代創作）音樂、流行音樂、跨界音樂與其他，更多的是音樂廳與演唱會場的直接拜訪聆賞，以及對於各種比賽、會議、出版等的多方關注，除此之外，親臨現場對於節目演出、會議報告等內容以及觀眾反應的獲取與觀察，則是相關子領域的重要資料來源。
    </p>
    <p><strong>三、人才培育</strong></p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本年鑑之人才培育數量調查，以大專院校系所為對象，整理各子領域評介專文後發現，各自領域人才培育方式不盡相同。</p>
    <p><strong>（一）傳統音樂中漢族音樂部分</strong></p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;南管音樂與北管音樂有國立臺北藝術大學傳統音樂學系學士班與碩士班，其中又可再細分為南管樂組與北管樂組，來進行人才培育的課程，在校生約有80人。客家音樂方面有國立臺灣戲曲學院，以十二年一貫戲曲人才養成學府，自國小、國中、高職至四技部（四年制技術學院制）一貫教育，培養優質戲曲專業人才。其中戲曲音樂學系、客家戲學系等，皆有開設客家音樂相關課程。至於福佬歌謠之人才培育，皆未列入大專院校的正式課程之中，多屬社團性質，或是以「本土語言課程」之名所安排的相關課程內容。
    </p>
    <p><strong>（二）傳統音樂中原住民音樂與宗教音樂領域</strong></p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;原住民音樂與宗教祀典音樂目前臺灣大專院校，未見單一的相關科系。原住民領域以多元族群以及相關知識領域的學習為主，例如東華大學、國立暨南大學、靜宜大學等大學設有相關學院、學程、專班。宗教音樂部分則大多於宗教系所之相關課程中進行人才培育，計有華梵大學、佛光大學、國立政治大學、中原大學、南華大學、真理大學、玄奘大學等7所大專院校，設有佛教學系、宗教學系及宗教研究所等，但並非針對音樂內容。
    </p>
    <p><strong>（三）藝術（當代創作）音樂</strong></p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;國樂與西樂人才在大專院校的培育部分，在臺灣有較為完整的教育體系。國樂方面有6所大專院校，分別為國立臺灣藝術大學、中國文化大學、國立臺北藝術大學、國立臺南藝術大學、南華大學及國立臺灣師範大學等，這些學校皆有學士班和碩士班，以及國立臺灣師範大學民族音樂研究所的碩士班，約1100人於相關科系、組別就讀。西樂方面，本年鑑中收錄之相關學校包含國小、國中、高中、大學、研究所等，其中國小68所、國中56所、高中41所、大學72所、研究所17所，超過萬名學子於音樂班、音樂科系、組別就讀。
    </p>
    <p><strong>（四）流行音樂與跨界音樂</strong></p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;流行音樂自2013年文化部開始推動設立流行音樂學程等會議後，近十年來各大專院校陸續成立相關學程，從學士、學士後學位學程、碩士班等流行音樂專業，將流行音樂納入系統性的正規教育體系。2022年計有國立臺灣師範大學、國立清華大學、輔仁大學、文化大學、中國科技大學、中原大學、國立臺南藝術大學、臺南應用科技大學、南臺科技大學、臺北城市科技大學、國立中山大學、遠東科技大學、佛光大學、醒吾科技大學等14所大專院校，約1500人於相關科系、組別就讀。跨界音樂則有國立臺灣藝術大學跨域表演藝術研究所，在校生人數約70人，培訓兼具國際宏觀與在地視野的跨域表演藝術研究人才。
    </p>
    <p><strong>四、統計數據</strong></p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;透過13個子領域對於其各自面向的關照，呈現在本年鑑的整體音樂數量上，可看見展演活動非常活躍，總共有6,268件，佔總體調查的57.8%，顯示了音樂中最重要的展示方式。這其中，又以流行音樂的2,057件為最大宗。而藝術（當代創作）音樂中以西方樂隊與樂器，或混合編制形式所展演的國人作品部分有1,356件，傳統音樂中的北管有1,044件，都顯示了音樂廳內與音樂廳外，在2022年都有生氣蓬勃的音樂活動。
    </p>
    <span>表2：各子領域呈現的七大觀察面向數據一覽</span>
    <table rules="all" border="1" style="border: 1px solid" cellpadding="5">
      <tbody>
        <tr>
          <td class="tableCenter" width="123">
            <p>觀察面向</p>
          </td>
          <td class="tableCenter" width="76">
            <p>展演活動</p>
          </td>
          <td class="tableCenter" width="76">
            <p>祭儀活動</p>
          </td>
          <td class="tableCenter" width="76">
            <p>推廣教育</p>
          </td>
          <td class="tableCenter" width="76">
            <p>傳習活動</p>
          </td>
          <td class="tableCenter" width="85">
            <p>國際與兩岸交流</p>
          </td>
          <td class="tableCenter" width="66">
            <p>研究與出版</p>
          </td>
          <td class="tableCenter" width="76">
            <p>文化政策</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="123">
            <p>南管音樂</p>
          </td>
          <td class="tableCenter" width="76">
            <p>115</p>
          </td>
          <td class="tableCenter" width="76">
            <p>88</p>
          </td>
          <td class="tableCenter" width="76">
            <p>71</p>
          </td>
          <td class="tableCenter" width="76">
            <p>63</p>
          </td>
          <td class="tableCenter" width="85">
            <p>1</p>
          </td>
          <td class="tableCenter" width="66">
            <p>12</p>
          </td>
          <td class="tableCenter" width="76">
            <p>7</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="123">
            <p>北管音樂</p>
          </td>
          <td class="tableCenter" width="76">
            <p>1044</p>
          </td>
          <td class="tableCenter" width="76">
            <p>160</p>
          </td>
          <td class="tableCenter" width="76">
            <p>39</p>
          </td>
          <td class="tableCenter" width="76">
            <p>28</p>
          </td>
          <td class="tableCenter" width="85">
            <p>2</p>
          </td>
          <td class="tableCenter" width="66">
            <p>22</p>
          </td>
          <td class="tableCenter" width="76">
            <p>47</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="123">
            <p>福佬歌謠</p>
          </td>
          <td class="tableCenter" width="76">
            <p>114</p>
          </td>
          <td class="tableCenter" width="76">
            <p>0</p>
          </td>
          <td class="tableCenter" width="76">
            <p>76</p>
          </td>
          <td class="tableCenter" width="76">
            <p>50</p>
          </td>
          <td class="tableCenter" width="85">
            <p>1</p>
          </td>
          <td class="tableCenter" width="66">
            <p>30</p>
          </td>
          <td class="tableCenter" width="76">
            <p>9</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="123">
            <p>客家音樂</p>
          </td>
          <td class="tableCenter" width="76">
            <p>283</p>
          </td>
          <td class="tableCenter" width="76">
            <p>66</p>
          </td>
          <td class="tableCenter" width="76">
            <p>123</p>
          </td>
          <td class="tableCenter" width="76">
            <p>27</p>
          </td>
          <td class="tableCenter" width="85">
            <p>0</p>
          </td>
          <td class="tableCenter" width="66">
            <p>14</p>
          </td>
          <td class="tableCenter" width="76">
            <p>23</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="123">
            <p>原住民音樂一*</p>
          </td>
          <td class="tableCenter" width="76">
            <p>142</p>
          </td>
          <td class="tableCenter" width="76">
            <p>179</p>
          </td>
          <td class="tableCenter" width="76">
            <p>33</p>
          </td>
          <td class="tableCenter" width="76">
            <p>22</p>
          </td>
          <td class="tableCenter" width="85">
            <p>2</p>
          </td>
          <td class="tableCenter" width="66">
            <p>21</p>
          </td>
          <td class="tableCenter" width="76">
            <p>17</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="123">
            <p>原住民音樂二*</p>
          </td>
          <td class="tableCenter" width="76">
            <p>66</p>
          </td>
          <td class="tableCenter" width="76">
            <p>33</p>
          </td>
          <td class="tableCenter" width="76">
            <p>41</p>
          </td>
          <td class="tableCenter" width="76">
            <p>43</p>
          </td>
          <td class="tableCenter" width="85">
            <p>9</p>
          </td>
          <td class="tableCenter" width="66">
            <p>14</p>
          </td>
          <td class="tableCenter" width="76">
            <p>0</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="123">
            <p>原住民音樂三*</p>
          </td>
          <td class="tableCenter" width="76">
            <p>136</p>
          </td>
          <td class="tableCenter" width="76">
            <p>135</p>
          </td>
          <td class="tableCenter" width="76">
            <p>73</p>
          </td>
          <td class="tableCenter" width="76">
            <p>48</p>
          </td>
          <td class="tableCenter" width="85">
            <p>0</p>
          </td>
          <td class="tableCenter" width="66">
            <p>8</p>
          </td>
          <td class="tableCenter" width="76">
            <p>3</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="123">
            <p>佛教、釋教音樂</p>
          </td>
          <td class="tableCenter" width="76">
            <p>15</p>
          </td>
          <td class="tableCenter" width="76">
            <p>582</p>
          </td>
          <td class="tableCenter" width="76">
            <p>50</p>
          </td>
          <td class="tableCenter" width="76">
            <p>255</p>
          </td>
          <td class="tableCenter" width="85">
            <p>3</p>
          </td>
          <td class="tableCenter" width="66">
            <p>3**</p>
          </td>
          <td class="tableCenter" width="76">
            <p>5</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="123">
            <p>道教、法教音樂</p>
          </td>
          <td class="tableCenter" width="76">
            <p>0</p>
          </td>
          <td class="tableCenter" width="76">
            <p>391</p>
          </td>
          <td class="tableCenter" width="76">
            <p>0</p>
          </td>
          <td class="tableCenter" width="76">
            <p>0</p>
          </td>
          <td class="tableCenter" width="85">
            <p>0</p>
          </td>
          <td class="tableCenter" width="66">
            <p>5</p>
          </td>
          <td class="tableCenter" width="76">
            <p>0</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="123">
            <p>國樂</p>
          </td>
          <td class="tableCenter" width="76">
            <p>668</p>
          </td>
          <td class="tableCenter" width="76">
            <p>0</p>
          </td>
          <td class="tableCenter" width="76">
            <p>234</p>
          </td>
          <td class="tableCenter" width="76">
            <p>19</p>
          </td>
          <td class="tableCenter" width="85">
            <p>1</p>
          </td>
          <td class="tableCenter" width="66">
            <p>82</p>
          </td>
          <td class="tableCenter" width="76">
            <p>60</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="123">
            <p>西樂及混合編制</p>
          </td>
          <td class="tableCenter" width="76">
            <p>1356</p>
          </td>
          <td class="tableCenter" width="76">
            <p>0</p>
          </td>
          <td class="tableCenter" width="76">
            <p>333</p>
          </td>
          <td class="tableCenter" width="76">
            <p>202</p>
          </td>
          <td class="tableCenter" width="85">
            <p>114</p>
          </td>
          <td class="tableCenter" width="66">
            <p>54</p>
          </td>
          <td class="tableCenter" width="76">
            <p>32</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="123">
            <p>流行音樂</p>
          </td>
          <td class="tableCenter" width="76">
            <p>2057</p>
          </td>
          <td class="tableCenter" width="76">
            <p>0</p>
          </td>
          <td class="tableCenter" width="76">
            <p>39</p>
          </td>
          <td class="tableCenter" width="76">
            <p>0</p>
          </td>
          <td class="tableCenter" width="85">
            <p>136</p>
          </td>
          <td class="tableCenter" width="66">
            <p>195</p>
          </td>
          <td class="tableCenter" width="76">
            <p>21</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="123">
            <p>跨界音樂與其他</p>
          </td>
          <td class="tableCenter" width="76">
            <p>272</p>
          </td>
          <td class="tableCenter" width="76">
            <p>0</p>
          </td>
          <td class="tableCenter" width="76">
            <p>43</p>
          </td>
          <td class="tableCenter" width="76">
            <p>7</p>
          </td>
          <td class="tableCenter" width="85">
            <p>15</p>
          </td>
          <td class="tableCenter" width="66">
            <p>11</p>
          </td>
          <td class="tableCenter" width="76">
            <p>5</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="123">
            <p>合計</p>
          </td>
          <td class="tableCenter" width="76">
            <p>6268</p>
          </td>
          <td class="tableCenter" width="76">
            <p>1634</p>
          </td>
          <td class="tableCenter" width="76">
            <p>1155</p>
          </td>
          <td class="tableCenter" width="76">
            <p>764</p>
          </td>
          <td class="tableCenter" width="85">
            <p>284</p>
          </td>
          <td class="tableCenter" width="66">
            <p>431</p>
          </td>
          <td class="tableCenter" width="76">
            <p>229</p>
          </td>
        </tr>
      </tbody>
    </table>
    <p></p>
    <span style="font-size:12px">*原住民音樂一：賽夏族、阿美族、卑南族、雅美族、太魯閣族、撒奇萊雅族</span><br>
    <span style="font-size:12px">*原住民音樂二：泰雅族、鄒族、邵族、布農族、噶瑪蘭族、賽德克族</span><br>
    <span style="font-size:12px">*原住民音樂三：排灣族、魯凱族、拉阿魯哇族、卡那卡那富族、平埔族</span><br>
    <span style="font-size:12px">**佛教、釋教音樂有關研究與出版觀察面向之統計，本應含括創作供養性音樂、哲理、儀軌、歷史、美學、全球化等相關出版品。但此處之數據，僅顯示此二宗教中純音樂出版品部分，並未將其他類型之出版品計算在內</span>
    <br>
    <p></p>
    <table cellpadding="5">
      <tbody>
        <tr>
          <td class="tableCenter">
            <img class="img70" src="./../../../assets/comment1/1.jpg" alt="" />
          </td>
        </tr>
        <tr>
          <td class="tableCenter">
            <p style="width:50%;margin:0 auto;" class="tableCenter">圖1：各子領域呈現的七大觀察面向百分比一覽</p>
          </td>
        </tr>
      </tbody>
    </table>
    <p></p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;藝術（當代創作）音樂與流行音樂部分，因較不具儀式性，因此未含有祭儀音樂部分。而宗教音樂中的佛釋與道法教，則以祭儀音樂呈現宗教的莊嚴性，因此件數也較多。另外原住民以及南管音樂和北管音樂部分，也有較多的祭儀音樂活動。
    </p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;推廣教育上，以藝術（當代創作）音樂為最大宗，不論國樂或西樂及混合編制，都有超過三百場的推廣教育活動。傳習部分，則以佛釋教的255件為最大宗。至於國際與兩岸交流上，受限於疫情，以及臺灣與中國的政治路線差異，除了西樂與流行音樂，有透過視訊與網際網路的國際音樂交流，則兩岸交流顯得非常冷清，各子領域幾乎都掛零，僅原住民卑南族南王部落於7月15日以線上方式，與由湖南省人民政府臺灣事務辦公室、湖南省民族宗教事務委員會、懷化市人民政府所共同主辦的「湘臺少數民族文化交流暨『遇見非遺』兩岸非物質文化創意活動」中的侗族，進行了文化交流。
    </p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;研究出版部分，傳統音樂在數量上，不如藝術（當代創作）音樂以及流行音樂的研究成果豐碩。</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;文化政策部分，以國樂與北管為大宗。另外財團法人國家文化藝術基金會於每年「演藝團隊年度獎助專案」中，自全國各地遴選之優秀表演藝術團隊：「TAIWAN
      TOP演藝團隊」，涵蓋各表演藝術領域，帶動臺灣表演藝術能量的擴張與匯聚，樹立正向循環的藝文生態，創造藝術的優質展現與無限可能。本年度獲得專案獎助的TAIWAN
      TOP演藝團隊共有91團。其中音樂類有20團：入圍團隊有福爾摩沙合唱團、木樓合唱團、台北室內合唱團、財團法人台北愛樂文教基金會、對位室內樂團、高雄市管樂團、巴洛克獨奏家樂團、台北青年管樂團、樂興之時管絃樂團、台北愛樂室內及管弦樂團、新古典室內樂團、巴雀藝術、MIT米特薩克斯風重奏團、時間藝術工作室、台灣絃樂團、小巨人絲竹樂團、新竹青年國樂團、財團法人拉縴人文化藝術基金會、臺北爵士大樂隊、天狼星口琴樂團等；相關戲曲類有台南人劇團、榮興客家採茶劇團等，也於本年鑑中有相關報導。
    </p>
    <span>表3：本年鑑收錄2022年TAIWAN TOP演藝團隊情形</span>
    <table rules="all" border="1" style="border: 1px solid" cellpadding="5">
      <tbody>
        <tr>
          <td class="tableCenter" width="95">&nbsp;</td>
          <td class="tableCenter" width="246">
            <p>活動月曆收錄團體</p>
          </td>
          <td class="tableCenter" width="151">
            <p>活動紀錄表報導團體</p>
          </td>
          <td class="tableCenter" width="151">
            <p>年度活動影像精選授權團體</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="95">
            <p>福佬歌謠</p>
          </td>
          <td class="tableCenter" width="246">
            <p>台南人劇團</p>
          </td>
          <td class="tableCenter" width="151">
            <p>台南人劇團</p>
          </td>
          <td class="tableCenter" width="151">
            <p>--</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="95">
            <p>客家音樂</p>
          </td>
          <td class="tableCenter" width="246">
            <p>榮興客家採茶劇團</p>
          </td>
          <td class="tableCenter" width="151">
            <p>榮興客家採茶劇團</p>
          </td>
          <td class="tableCenter" width="151">
            <p>榮興客家採茶劇團</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="95">
            <p>國樂</p>
          </td>
          <td class="tableCenter" width="246">
            <p>小巨人絲竹樂團</p>
            <p>新竹青年國樂團</p>
          </td>
          <td class="tableCenter" width="151">
            <p>小巨人絲竹樂團</p>
            <p>新竹青年國樂團</p>
          </td>
          <td class="tableCenter" width="151">
            <p>--</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="95">
            <p>西樂及混合編制</p>
          </td>
          <td class="tableCenter" width="246">
            <p>木樓合唱團、台北室內合唱團、台北青年管樂團、台灣絃樂團、巴洛克獨奏家樂團、巴雀藝術、對位室內樂團、MIT米特薩克斯風重奏團、時間藝術工作室</p>
          </td>
          <td class="tableCenter" width="151">
            <p>台北室內合唱團</p>
            <p>對位室內樂團</p>
            <p>時間藝術工作室</p>
          </td>
          <td class="tableCenter" width="151">
            <p>--</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter" width="95">
            <p>跨界音樂與其他</p>
          </td>
          <td class="tableCenter" width="246">
            <p>新古典室內樂團</p>
          </td>
          <td class="tableCenter" width="151">
            <p>--</p>
          </td>
          <td class="tableCenter" width="151">
            <p>新古典室內樂團</p>
          </td>
        </tr>
      </tbody>
    </table>
    <p></p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;整體而言，即使在數量的蒐集上，各子領域可能仍有遺漏，但透過數據，也讓我們對於臺灣音樂的呈現面向，有一個大致的了解。</p>
    <h3>參、南管音樂及北管音樂團體基礎概況分析</h3>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;另於本年度新增南管音樂及北管音樂團體之基礎概況調查：針對南管音樂及北管音樂兩個子領域，以郵寄、網路問卷或親自訪問等方式，對於表演藝術團體進行基礎概況的普查。問卷內容包含：團體名稱、負責人、地址、電話、其他聯絡方式、成立時間、立案情形、團隊榮譽以及2022年活動方式、收入狀況、支出狀況、活動概況、人力結構、人力來源、傳播方式、推廣研習活動之效益、面臨困境等項目。藉由調查表成果，期望能更清楚了解各南管團體的生態。
    </p>
    <strong>一、南管音樂團體基礎概況說明</strong>
    <p></p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;南管音樂觀察團體共計66團，依填寫意願發出問卷63團，回收51團（回收率81%，立案率65%）。</p>
    <table rules="all" border="1" style="border: 1px solid" cellpadding="5">
      <tbody>
        <tr>
          <td class="tableCenter">
            <img class="contentImg" src="./../../../assets/comment1/2.jpg" alt="" />
          </td>
          <td class="tableCenter">
            <img class="contentImg" src="./../../../assets/comment1/3.jpg" alt="" />
          </td>
        </tr>
        <tr>
          <td class="tableCenter">
            <p class="tableCenter">圖2：營運模式與活動概況</p>
          </td>
          <td class="tableCenter">
            <p class="tableCenter">圖3：營運收入狀況</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter">
            <img class="contentImg" src="./../../../assets/comment1/4.jpg" alt="" />
          </td>
          <td class="tableCenter">
            <img class="contentImg" src="./../../../assets/comment1/5.jpg" alt="" />
          </td>
        </tr>
        <tr>
          <td class="tableCenter">
            <p class="tableCenter">圖4：人數規模</p>
          </td>
          <td class="tableCenter">
            <p class="tableCenter">圖5：人力結構分析</p>
          </td>
        </tr>
      </tbody>
    </table>
    <p></p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;南管音樂團體中，多數為業餘團體，但有3團是以職業演出為主。另今年調查的66團中，最少有6團成立於中華民國成立之前。在營運模式與活動概況上，職業演出為主佔6%，業餘休閒為主佔有78%，以民間傳統廟會及祭典、教學與推廣研習、同好切磋三者為主要活動類別。
    </p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;團體營運模式中的收支部分，此處以團體勾選最多者為例，可發現南管團體年收入在25萬元以下者有60%，而經費來源主要為自籌，或為廟方贊助，或為團員自行負擔。但另有3個以職業演出為主的團體中，兩團有著100萬元以上的年收入。年支出部分則有69%是在25萬元以下，多使用於民間傳統廟會及祭典活動、教學推廣與同好切磋的支出。但3個職業演出為主的團體，年支出都在100萬元以上，大多數團體，均能達到損益平衡。
    </p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;人數規模上，南管音樂團體人數規模較小，大多為50人以內，其中20人以下更是佔了51%。由於南管音樂團體多為業餘團體，因此多無專職人員，業餘或兼職人員比例高達99%。他們薪資收入或不固定，或偏少。性別比例上，以女性居多。至於人力來源，以相關科系學生居多，推廣研習活動參與者次之。
    </p>

    <strong>二、北管音樂團體基礎概況說明</strong>
    <p></p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;北管音樂觀察團體共計119團，依填寫意願發出問卷86團，回收45團（回收率52%，立案率71%）。</p>

    <table rules="all" border="1" style="border: 1px solid" cellpadding="5">
      <tbody>
        <tr>
          <td class="tableCenter">
            <img class="contentImg" src="./../../../assets/comment1/6.jpg" alt="" />
          </td>
          <td class="tableCenter">
            <img class="contentImg" src="./../../../assets/comment1/7.jpg" alt="" />
          </td>
        </tr>
        <tr>
          <td class="tableCenter">
            <p class="tableCenter">圖6：營運模式與活動概況</p>
          </td>
          <td class="tableCenter">
            <p class="tableCenter">圖7：營運收入狀況</p>
          </td>
        </tr>
        <tr>
          <td class="tableCenter">
            <img class="contentImg" src="./../../../assets/comment1/8.jpg" alt="" />
          </td>
          <td class="tableCenter">
            <img class="contentImg" src="./../../../assets/comment1/9.jpg" alt="" />
          </td>
        </tr>
        <tr>
          <td class="tableCenter">
            <p class="tableCenter">圖8：人數規模</p>
          </td>
          <td class="tableCenter">
            <p class="tableCenter">圖9：人力結構分析</p>
          </td>
        </tr>
      </tbody>
    </table>
    <p></p>

  <p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;北管音樂團體中，多數為業餘休閒性質，由於疫情緣故，本年度許多團體並未有演出行為。在本年度觀察之北管團體中，有9%為職業性團體，另有10團成立時間為中華民國成立之前，時間超過100年以上。在營運模式與活動概況上，職業演出為主佔9%，業餘休閒為主佔有84%，以民間傳統廟會及祭典所佔80%為最大宗，其次則為佔9%的教學與推廣研習，再其次為同好切磋。
  </p>
  <p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;團體營運模式中的收支部分，此處以團體勾選最多者為例，可發現北管團體年收入在25萬元以下有40%，是為最大宗，而經費來源主要為自籌。至於年支出則有31%是在25萬元以下，是為最大宗，多使用於民間傳統廟會及祭典。團體中有58%為收支平衡，7%有盈餘，18%呈現虧損狀態。
  </p>
  <p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;人數規模上，北管音樂團體人數規模較大，20人以上就佔了七成，100人以上的團體也有4%的比例。由於北管音樂團體多為業餘團體，因此多無專職人員，業餘或兼職人員比例高達94%。他們薪資收入或不固定，或偏少。性別比例上，以男性居多。至於人力來源，以家族成員居多，專職人力的部分，也是以家族成員為主。
  </p>
  <p><strong>三、困境與復振</strong></p>
  <p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;至於屬於傳統音樂型態的南管音樂與北管音樂，主要面臨困境為人才斷層、傳統藝術價值傳承困難，國內民眾參與意願低。另在舉辦各種傳統活動時，不易獲得資金，或不知資金獲得管道，此部分需政府多加關懷與輔導。
  </p>
  <h3>肆、未來研究規劃與建議</h3>
  <p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;許多事件的發生，在當年多樣紛雜、百物齊陳的情況下，可能並未能立即顯現其特殊性，但在時間長河下，歷史學者的針砭，若干年後若需回頭翻閱，則透過年鑑的記載，當年發生時的資料，早已蒐集齊備。因此年鑑雖然每年看來似乎大同小異，卻保留了當年瞬間所發生事件的第一手紀錄，沒有事後的加油添醋、錦上添花，完全是樸質的呈現了當下的原始樣貌與觀點。
  </p>
  <p><strong>一、未來研究規劃</strong></p>
  <p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本年鑑的最大優點，在於邀請各領域專業人士參與資料蒐集與寫作。不同領域具有一定的專業性，而在此領域努力的學者，為我們留下值得保存的紀錄，讓我們有機會了解不同領域在不同年份下的發展。專家學者不但訊息來源與相關資料蒐集方面，都比非專業人士敏銳，且管道多樣，訊息量充沛。加上對於活動紀錄專業的選擇與描述，都讓一般大眾能藉此有專業觀點的認識。
  </p>
  <p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;但國內在專業人才的培訓上並不平均。例如原住民音樂族群眾多，活動頻繁，但因地理位置分布廣泛，不但在蒐集資料上需更多人力的支持，蹲點紀錄也所費不貲。加以原住民研究人才培育不易，一位專家學者必須同時兼顧多個族群，造成願意承擔此領域的專業人才難尋。
  </p>
  <p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本年鑑的第二優點，在於其內容完備。從2009年臺灣年鑑開始執行時，僅集中於傳統音樂，到2018年開始含括了藝術（當代創作）、流行與跨界音樂等內容。一般民眾因此能透過一本年鑑，了解當年度臺灣音樂全貌。其中除了在傳統音樂方面，許多訊息不見與網路，需親自蒐集，2018年新加入的領域，其資料雖在網路等相關媒體已相當豐富，但訊息卻是凌亂紛雜。因此專家的整理與歸納，將資料分類置入一定的範疇中，對於一般希望了解當年音樂內容的民眾，提供了系統性認識的可能性。
  </p>
  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;但本年鑑有流行音樂子領域訊息，與因為國家對於流行音樂的重視，有例如文化內容策進院所進行的《2021年台灣文化內容產業調查報告III
    流行音樂、廣播產業》中所見到，對於流行音樂產業的調查報告，似乎有所重疊。但文化內容策進院的調查重點，在於流行音樂市場銷售金額狀況、數位串流音樂熱門歌曲狀況、國內外歌手/樂團演出之售票場次，我國廣播產業營業收入趨勢等內容，與本年鑑中所重視的音樂文化生態、活動蹲點觀察等有所不同。再者，不同調查不但常各有所重，專家學者們的觀點也常有差異，因此即使內容範圍看似均針對流行音樂，但所呈現的結果仍會有所不同。
  </p>
  <p><strong>二、研究建議</strong></p>
  <p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;音樂因其抽象性，是所有藝術中最需具備專業性者，專業人才較其他藝術領域少，但這並不表示此專業應被忽略。況且我國其實已具備許多音樂相關專業人士，故應可打破既有各子領域需統籌較大內容範圍的情形，讓更多新興一代的年輕學者可以其所學專長，共同參與歷史書寫。至於流行音樂部分，雖有其他機構的類似統計數據，但此領域仍不應置於年鑑之外，反之更應與相關單位協調聯手，完備一本音樂年鑑所需具備的不同面向。此外，機構工作有重疊性，多因對於音樂機構的規劃未見統一性，才導致流行音樂子領域被質疑與其他音樂單位所做重疊的問題。應成立層級較高之臺灣音樂中心，統領臺灣音樂各項事務，避免重複，浪費公帑，才為解決此問題根本之道。
  </p>
  <p>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;許多事件，如未能在當年立即記錄，事後的追憶將參雜更多主觀色彩，另也讓臺灣音樂史研究所需的第一手資料，落入民間愛樂人的收藏中，之後必須再次從民間愛樂人士手中收購。文化是國家的軟實力，我們音樂界責無旁貸應做之事，年鑑則為其中要務。透過年鑑可了解歷史、盤點事件、認識自我。因此如能持續進行，臺灣音樂史的樣貌將更加清晰。
  </p>
  <hr />
  <p></p>
  <small class="mobileSmall" style="text-align:left;word-break: break-all;">
    <sup>1</sup>參考疫情指揮中心line「疫管家」訊息。<br>
  </small>
</div></template>
<script>
export default {
  data() {
    return {
    };
  },
  created() {
    document.querySelector('.viewRight > div:first-child').scrollTop = 0
  },
};
</script>
